import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import ControlButton from '../../../../../../generic/buttons/ControlButton'
import BasketIcon from '../../../../../../generic/icons/IconLib/BasketIcon'
import UserIcon from '../../../../../../generic/icons/IconLib/UserIcon'
import Title from '../../../../../../generic/Title/Title'
import TitlesList from '../../../../../../generic/titlesRowItem/TitlesList'
import { ContentWrapper } from '../../../../../../generic/Layouts/orderListStyles'
import { HeaderInformationInnerItem, HeaderInformationItem, HeaderInformationWrapper, HeaderItemInfo } from '../../likutSection/LikutSectionMain'
import SiumLikutItem from './SiumLikutItem'
import { useTranslation } from 'react-i18next'
import PalletsToChange from '../../../../../../generic/modals/PalletsToChange'

const SlideViewport = styled.div`
    width: 100%;
    height: 70vh;
    max-height: 100%;
    overflow: hidden; /* clips the off-screen second panel during the translateX slide */
    /* Force an LTR track so the flex-row order + translateX slide stay physical
       (the surrounding AppModal sheet is RTL). Inner content is set back to RTL. */
    direction: ltr;
`
const  InnterTransformWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    /* overflow: hidden; */
    flex-flow: row;
    gap: 1em;
    transform: ${props => props.$isPossitionOnPallets ? 'translateX(calc(-100% - 1em))' : 'translateX(0)'};
    transition: all 0.3s ease-in-out;
`
const PanelScroll = styled.div`
    width: 100%;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    direction: ltr;
`
const MainContainer = styled.div`
    min-width: 100%;
    height: 100%;
    background: ${props => props.$isPossitionOnPallets ? '#fff' : '#e9f0f0'};
    border-radius: 30px;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-flow: column;
    justify-content: flex-start;
    align-items: center;
    padding: 0 0.5em 1em;
    gap: 0.5em;
    direction: rtl; /* content (cards, header, buttons) stays RTL inside the LTR track */
`
export const ButtonContainer = styled.div`
    width: 90%;
    flex-shrink: 0;
    display: flex;
    gap: 0.5em;
    justify-content: space-between;

`
export default function SiumLikutModal({
    azmanaDetails, azmanotListForSiumLikut, siumLikut, 
    siumModalIsOpen, setSiumModalIsOpen, 
    isWeightCalculation, palletModalProps
}) {
    const [t] = useTranslation(['likut', 'buttons']);
    const likutInfo = useSelector(info => info.likut);
    const [isPossitionOnPallets, setIsPossitionOnPallets] = useState(false);
    const handlePossitionOnPallets = () => {
        setIsPossitionOnPallets(!isPossitionOnPallets);
    }
    const isExistProblem = azmanotListForSiumLikut?.some(e => e.ChangeReason === 0 || e.ChangeReason === 4)
    const palletModalPropsWithCallback = {
        ...palletModalProps,
        callback: async () => {
            if(isExistProblem) {
                return
            }
            console.log('siumLikut')
            await siumLikut(likutInfo.azmanaNum)  
            console.log('siumLikut2')
        },
        saveFunc: () => {
            setSiumModalIsOpen(false)
        }
    }
    return (
        <SlideViewport>
                <InnterTransformWrapper $isPossitionOnPallets={isPossitionOnPallets}>
                    <MainContainer >
                        <HeaderInformationWrapper style={{ width: '100%' }}>
                            <HeaderInformationInnerItem>
                                <HeaderInformationItem >
                                    <HeaderItemInfo>
                                        {likutInfo.azmanaNum}
                                    </HeaderItemInfo>
                                    <HeaderItemInfo>
                                        <BasketIcon />
                                    </HeaderItemInfo>
                                </HeaderInformationItem>
                                <HeaderInformationItem >
                                    <HeaderItemInfo>
                                        {azmanaDetails?.Customer_Name}
                                    </HeaderItemInfo>
                                    <HeaderItemInfo>
                                        <UserIcon />
                                    </HeaderItemInfo>
                                </HeaderInformationItem>
                            </HeaderInformationInnerItem>
                        </HeaderInformationWrapper>
                        <PanelScroll>
                                <TitlesList
                                    list={azmanotListForSiumLikut}
                                    Element={SiumLikutItem}
                                    uniqueKey={'id'}
                                    additionalData={{
                                        isWeightCalculation: isWeightCalculation
                                    }}
                                />
                        </PanelScroll>
                        <ButtonContainer>
                            <ControlButton 
                                
                                lable={t("back", {ns: 'buttons'})}
                                handleClick={() => {setSiumModalIsOpen(false)}}
                            />
                            {
                                !isExistProblem && (
                                    <ControlButton
                                        primal={!isPossitionOnPallets}
                                        lable={isPossitionOnPallets ? 'black' : 'המשך'}
                                        handleClick={() => {
                                            handlePossitionOnPallets()
                                        }}
                                    />
                                )
                            }
                           
                            
                        </ButtonContainer>
                    </MainContainer>
                    <MainContainer $isPossitionOnPallets={isPossitionOnPallets}>

                        <Title
                            color={"#297F76"}
                            label={'כמות משטחים'}
                        />
                        <PanelScroll>
                            <PalletsToChange {
                                ...palletModalPropsWithCallback}
                            />
                        </PanelScroll>
                        <ButtonContainer>
                            <ControlButton
                                lable={t("back", {ns: 'buttons'})}
                                handleClick={() => {setSiumModalIsOpen(false)}}
                            />

                        </ButtonContainer>
                    </MainContainer>
                </InnterTransformWrapper>
        </SlideViewport>
    )
}
